/* eslint-disable */
import {
  createStyles,
  Theme,
  withStyles,
} from "@material-ui/core";
import { FormControl, FormLabel, Textarea } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Component } from "react";
import { connect } from "react-redux";

import {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
} from "../../../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    accordion: {
      borderRadius: "10px",
      boxShadow: "none",
    },
  });

class EmailProperties extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  handleChangeProperty(e: any, prop: any) {
    this.props.edit_Properties({
      key: prop.key,
      value: e.target
        ? e.target.checked !== undefined
          ? e.target.checked
          : e.target.value
        : e.value,
    });
  }
  
  render() {
    const { classes, t } = this.props;
    return (
      <Accordion className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#AE0064" }} />}
        aria-controls="panel2a-content"
        id="modules"
      >
        <Typography className={classes.heading}>
          {"Email templates"}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "CONTACT_US_MESSAGE_EN" && (
                <FormControl id="contactUsMessageEn">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <Textarea
                    style={{ height: 200 }}
                    bg="white"
                    type="text-area"
                    value={this.state.contactEn || property.value}
                    onChange={(e: any) => {
                      this.setState({ contactEn: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                  />
                </FormControl>
              )
          )}
      </AccordionDetails>
      <AccordionDetails>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "CONTACT_US_MESSAGE_FR" && (
                <FormControl id="contactUsMessageFr">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <Textarea
                    style={{ height: 200 }}
                    bg="white"
                    type="text-area"
                    value={this.state.contactFr || property.value}
                    onChange={(e: any) => {
                      this.setState({ contactFr: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                  />
                </FormControl>
              )
          )}
      </AccordionDetails>
      <AccordionDetails>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "CONTACT_US_MESSAGE_ES" && (
                <FormControl id="contactUsMessageEs">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <Textarea
                    style={{ height: 200 }}
                    bg="white"
                    type="text-area"
                    value={this.state.contactEs || property.value}
                    onChange={(e: any) => {
                      this.setState({ contactEs: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                  />
                </FormControl>
              )
          )}
      </AccordionDetails>
      <AccordionDetails>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "CONTACT_US_MESSAGE_IT" && (
                <FormControl id="contactUsMessageIt">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <Textarea
                    style={{ height: 200 }}
                    bg="white"
                    type="text-area"
                    value={this.state.contactIt || property.value}
                    onChange={(e: any) => {
                      this.setState({ contactIt: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                  />
                </FormControl>
              )
          )}
      </AccordionDetails>
    </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(EmailProperties)));
